import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import FichaTecnicaModalSubproducto from "../../../shared/components/FichaTecnicaModalSubproducto.js";

const TableSubproductos = ({
  header,
  subproductos,
  loading,
  globalFilterValue,
  handleEditSubproducto,
  handleChangeEstadoSubproducto,
  nombreEmpresa,
}) => {
  const [showFichaModal, setShowFichaModal] = useState(false);
  const [selectedSubproductoFicha, setSelectedSubproductoFicha] = useState(null);

  const openFichaModal = (subproducto) => {
    setSelectedSubproductoFicha(subproducto);
    setShowFichaModal(true);
  };

  const closeFichaModal = () => {
    setShowFichaModal(false);
    setSelectedSubproductoFicha(null);
  };

  const estadoBodyTemplate = (rowData) => {
    const activo = rowData.activo === true || rowData.activo === 1;
    return (
      < >
        {activo ? (
          <Button
              icon="pi pi-check"
              className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2"
              outlined
              tooltip="Subproducto activo"
              tooltipOptions={{ position: 'top' }}
          />
          ) : (
          <Button
              icon="pi pi-times"
              className="p-button-rounded p-button-danger p-button mr-2 mb-2 mt-2"
              onClick={() => {}}
              outlined
              tooltip="Subproducto inactivo"
              tooltipOptions={{ position: 'top' }}
          />
          )}
      </>                    
    );
  };

  const accionesBodyTemplate = (rowData) => {
    const activo = rowData.activo === true || rowData.activo === 1;
    return (
      <>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2"
          tooltip={activo ? "Editar Subproducto" : "Subproducto inactivo, actívelo para editar"}
          tooltipOptions={{ position: "top" }}
          label="Editar"
          outlined
          onClick={() => handleEditSubproducto(rowData)}
          disabled={!activo}
        />
        <Button
          icon="pi pi-file-o"
          className="p-button-rounded p-button-info p-button mr-2 mb-2 mt-2"
          tooltip="Ver Ficha Técnica"
          tooltipOptions={{ position: "top" }}
          label="Ficha"
          outlined
          onClick={() => openFichaModal(rowData)}
        />
        <Button
          icon={activo ? "pi pi-power-off" : "pi pi-check-circle"}
          className={`p-button-rounded p-button p-button mr-2 mb-2 mt-2 ${
            activo ? "p-button-danger" : "p-button-info"
          }`}
          tooltip={activo ? "Desactivar Subproducto" : "Activar Subproducto"}
          tooltipOptions={{ position: "top" }}
          label={activo ? "Desactivar" : "Activar"}
          outlined
          onClick={() => handleChangeEstadoSubproducto(rowData)}
        />
      </>
    );
  };

  const incluidoBodyTemplate = (rowData) => {
    const incluido = rowData.incluido === true || rowData.incluido === 1;
    return (
      <>
        {incluido ? (
          <span>Incluido</span>
        ) : (
          <span>Adicional</span>
        )}
      </>
    );
  }

  return (
    <>
    <DataTable
      header={header ? header : `Se encontraron ${subproductos.length} subproductos`}
      value={subproductos}
      className="p-datatable-gridlines"
      showGridlines
      paginator
      rows={10}
      rowsPerPageOptions={[10, 20, 50, 100]}
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
      currentPageReportTemplate={`Mostrando {first} a {last} de {totalRecords} subproductos de ${nombreEmpresa}`}
      dataKey="id"
      loading={loading}
      emptyMessage="No se encontraron subproductos."
      stripedRows="true"
      id="subproductosEntidadTable"
      globalFilter={globalFilterValue}
      globalFilterFields={["descripcion", "tipo"]}
      tableStyle={{
        tableLayout: "fixed",
        width: "100%",
        minWidth: "900px",
      }}
      scrollHeight="57vh"
      scrollable
      reorderableColumns
      resizableColumns
      columnResizeMode="fit"
    >
      <Column
        field="descripcion"
        header="Descripción"
        sortable
        style={{ width: "22%" }}
        bodyStyle={{ overflow: "hidden" }}
        body={(rowData) => (
          <span
            style={{
              display: "block",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={rowData.descripcion}
          >
            {rowData.descripcion}
          </span>
        )}
      />
      <Column
        field="nombre_empresa"
        header="Empresa"
        sortable
        style={{ width: "12%" }}
        body={(rowData) => rowData.nombre_empresa || "-"}
      />
      <Column field="tipo" header="Tipo" sortable style={{ width: "18%" }} />
      <Column body={incluidoBodyTemplate} header="Incluido" sortable style={{ width: "18%" }} />
      <Column field="metraje" header="Metraje" sortable style={{ width: "10%" }} />
      <Column
        field="perfil"
        header="Perfil"
        sortable
        style={{ width: "15%" }}
        body={(rowData) => rowData.perfil || "-"}
      />
      <Column field="activo" header="Estado" body={estadoBodyTemplate} style={{ width: "12%" }} />
      <Column header="Acciones" body={accionesBodyTemplate} style={{ width: "30%" }} />
    </DataTable>

    <FichaTecnicaModalSubproducto
      visible={showFichaModal}
      onHide={closeFichaModal}
      subproductoId={selectedSubproductoFicha?.id}
      subproductoDescripcion={selectedSubproductoFicha?.descripcion}
    />
    </>
  );
};

export default TableSubproductos;
